import React, { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import '../css/Navbar.css';

const Navbar = () => {

  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  return (
    <div className="navbar">
      {/* First Row */}
      <div className="navbar-row top-row">
        <div className="left-menu">
          <span>PV Build</span>
          <div className="dropdown">
            <div className="dropdown-toggle">
              <span>Project Name</span> 
              <FaChevronDown size={16} style={{ color: '#ffffff' }} />
            </div>
            <div className="dropdown-menu">
              <div className="dropdown-item">Option 1</div>
              <div className="dropdown-item">Option 2</div>
              <div className="dropdown-item">Option 3</div>
            </div>
          </div>
        </div>

        <div className="right-menu">
          <div className="search-bar">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#808080" /* Icon color */
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="search-icon"
            >
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="16" y1="16" x2="22" y2="22"></line>
            </svg>
            <input
              type="text"
              value={searchQuery}
              onChange={handleSearchChange}
              placeholder="Cross Project Search"
              className="search-input"
            />
          </div>
          <div>
            <div className="user-info">Mr. Ameer Hamza</div>
            <div className="user-company">Air Products EPC</div>
          </div>
          <div className="help">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ffffff"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M9.09 9a3 3 0 1 1 5.82 1c0 1.5-1.5 2-1.5 2"></path>
              <line x1="12" y1="17" x2="12" y2="17"></line>
            </svg>

          </div>
          <div className="alert">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ffffff"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>


          </div>
        </div>

      </div>

      {/* Second Row */}
      <div className="navbar-row bottom-row">
        <div className="menu-items">

          <a href="#">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="9" y1="9" x2="15" y2="9"></line>
              <line x1="9" y1="13" x2="15" y2="13"></line>
              <line x1="9" y1="17" x2="15" y2="17"></line>
              <polyline points="5 9 7 11 11 7"></polyline>
            </svg>
            Tasks
          </a>
          <a href="#">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
              <polyline points="2 7 2 17 12 22 22 17 22 7"></polyline>
              <line x1="12" y1="12" x2="12" y2="22"></line>
            </svg>

            Models
          </a>
          <div className="dropdown">
            <a href="#">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
                <line x1="10" y1="9" x2="8" y2="9"></line>
              </svg>

              Documents
            </a>
            <div className="dropdown-container-overlay"></div>
            <div className="dropdown-container">
              <div className="dropdown-main">
                <div className="dropdown-menu-left">
                  <div className="menu-top">
                    <span className="menu-title">Search</span>
                    <a href="/documents">Document Register</a>
                    <a href="#">Drawings</a>
                    <a href="#">Temporary Files</a>
                  </div>
                  <div className="menu-bottom">
                    <span className="menu-title">Actions</span>
                    <a href="#">Multiple File Upload</a>
                    <a href="#">View Outstanding Print Requests</a>
                    <a href="#">Specification Reader</a>
                  </div>
                </div>
                <div className="dropdown-menu-right">
                  <div className="menu-top">
                    <span className="menu-title">My Organization's Searches</span>
                    <a href="#">IFC Drawings - BESS</a>
                    <a href="#">IFC Drawings - Solar Farm</a>
                    <a href="#">IFC Drawings - Wind Farm</a>
                  </div>
                  <div className="menu-bottom">
                    <span className="menu-title">Standard Searches</span>
                    <a href="#">Approved</a>
                    <a href="#">Drawings modified today</a>
                    <a href="#">Issued for approval</a>
                    <a href="#">Temporary files uploaded by me today</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="dropdown">
            <a href="#">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="3" y="4" width="18" height="16" rx="2" ry="2"></rect>
                <polyline points="3 6 12 13 21 6"></polyline>
              </svg>
              Mail
            </a>
            <div className="dropdown-container-overlay"></div>
            <div className="dropdown-container">
              <div className="dropdown-main">
                <div className="dropdown-menu-left">
                  <div className="menu-top">
                    <span className="menu-title">Search</span>
                    <a href="/dashboard">All</a>
                    <a href="/search-mail">Inbox</a>
                    <a href="#">Sent</a>
                    <a href="#">Drafts</a>
                  </div>
                  <div className="menu-bottom">
                    <span className="menu-title">Create New</span>
                    <a href="/new-mail">Blank Mail</a>
                  </div>
                  <div className="menu-bottom">
                    <span className="menu-title">Actions</span>
                    <a href="#">Register Incoming Mail</a>
                    <a href="#">Mail Approvals</a>
                  </div>
                </div>
                <div className="dropdown-menu-right">
                  <div className="menu-top">
                    <span className="menu-title">Standard Searches</span>
                    <a href="#">My mail received today</a>
                    <a href="#">My mail sent today</a>
                    <a href="#">My Outstanding & Overdue mail</a>
                    <a href="#">Org mail not Closed Out</a>
                    <a href="#">Org mail received in last 30 days</a>
                    <a href="#">Org Outstanding & Overdue mail</a>
                    <a href="#">RFIs received report</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <a href="#">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M10 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-8l-2-2z"></path>
            </svg>

            Directory
          </a>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
